import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RecruitAccountability() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Recruit an accountability partner" />
        <blockquote>
          “Iron sharpens iron, so one man sharpens another.” (Proverbs 27:17)
        </blockquote>

        <p>An accountability partner is someone with whom we meet regularly and get to know on a personal level, with whom we pray and share about our successes and needs. This person is not afraid to ask us tough questions or point out our sins to us. Men in particular need an accountability partner, a respected, trusted, spiritually mature, and likeminded man with whom to meet on a regular basis, preferably weekly. Spouses are not preferred as accountability partners. Personal things shared in these meetings should be kept confidential, for once trust is broken the relationship can no longer function effectively. Spend the majority of the time praying together, praying for one another and the needs of the church, community, and nation. An accountability partner is of great practical value in our struggle to overcome temptation. First of all, our accountability partner can be praying for us in difficult times. This alone is worth the time and effort to meet with someone on a regular basis. Secondly, if we know that our accountability partner will be asking us how we are doing, particularly in the areas of sin and temptation, it will be more difficult and embarrassing to tell them we failed to overcome temptation, so we will try harder. Find an accountability partner and meet regularly with them. The more time you spend in prayer together, the more progress you will see in overcoming temptation.</p>
        <br />

        <ul>
          <li>
            <strong>Confess your sins to another and pray for one another.</strong><br />
            <em>James 5:16</em>
          </li>
          <br />
          <li>
            <strong>Seek to sharpen and encourage others.</strong><br />
            <em>Proverbs 27:17, Colossians 3:16</em>
          </li>
          <br />
          <li>
            <strong>Solicit and welcome the rebuke and admonishment of others.</strong><br />
            <em>Psalm 141:5, Proverbs 27:6, 9, 28:23</em>
          </li>
          <br />
          <li>
            <strong>Do not isolate or insulate yourself from other believers.</strong><br />
            <em>Hebrews 3:13, 10:24-25</em>
          </li>
          <br />
          <li>
            <strong>Seek, receive, and do not ignore godly wisdom and counsel.</strong><br />
            <em>Psalm 32:8, Proverbs 4:1-22, 5:12-14, 11:14, 12:15, 13:10, 15:22, 19:20-21, 24:6, 27:9</em>
          </li>
          <br />
          <li>
            <strong>Restore others who have stumbled, looking to yourself, lest you also be tempted.</strong><br />
            <em>Galatians 6:1</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
